import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { handleActions } from 'redux-actions';
import { setBackground, previewBackground } from './actions';
import { reduxKey } from './constants';
const actionHandlers = handleActions({
    [setBackground.toString()]: (state, { payload: { deviationId , backgroundId  }  })=>_object_spread_props(_object_spread({}, state), {
            [deviationId]: {
                backgroundId
            }
        }),
    [previewBackground.toString()]: (state, { payload: { backgroundId  }  })=>_object_spread_props(_object_spread({}, state), {
            backgroundPreview: backgroundId
        })
}, {});
export default {
    [reduxKey]: actionHandlers
};
